/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToggleMarketingBlacklistResponse
 */
export interface ToggleMarketingBlacklistResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleMarketingBlacklistResponse
     */
    marketingBlacklist: boolean;
}

/**
 * Check if a given object implements the ToggleMarketingBlacklistResponse interface.
 */
export function instanceOfToggleMarketingBlacklistResponse(value: object): value is ToggleMarketingBlacklistResponse {
    if (!('marketingBlacklist' in value) || value['marketingBlacklist'] === undefined) return false;
    return true;
}

export function ToggleMarketingBlacklistResponseFromJSON(json: any): ToggleMarketingBlacklistResponse {
    return ToggleMarketingBlacklistResponseFromJSONTyped(json, false);
}

export function ToggleMarketingBlacklistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToggleMarketingBlacklistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'marketingBlacklist': json['marketingBlacklist'],
    };
}

export function ToggleMarketingBlacklistResponseToJSON(json: any): ToggleMarketingBlacklistResponse {
    return ToggleMarketingBlacklistResponseToJSONTyped(json, false);
}

export function ToggleMarketingBlacklistResponseToJSONTyped(value?: ToggleMarketingBlacklistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'marketingBlacklist': value['marketingBlacklist'],
    };
}

